export const SOLUTIONS_EVENTS = {
  SIGMA_WORKBOOK_SOLUTION_CREATED: "Sigma Workbook Solution Created",
} as const
